/* @flow */
import cx from 'classnames';
import * as React from 'react';

import './styles/AppLayoutContentView.scss';

export default class AppLayoutContentView extends React.Component<{
  header: React.Node,
  sidebar?: React.Node,
  children: React.Node,
  className?: ?string,
}> {
  render() {
    const { children, className, header, sidebar } = this.props;

    return (
      <div className={cx('AppLayoutContentView', className)}>
        {sidebar && (
          <div className="AppLayoutContentView-sidebar">
            {header}
            {sidebar}
          </div>
        )}
        {children}
      </div>
    );
  }
}
